import { createApp, nextTick } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./tailwind.css";
import Vue3Toasity from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import VueCookies from "vue-cookies";

// import fontawesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faMicrosoft } from "@fortawesome/free-brands-svg-icons";
import { faUser, faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import {
  faUnlockAlt,
  faMobileAlt,
  faXmark,
  faList,
  faHandshake,
  faUserAlt,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faCircleUser,
  faSignOut,
  faBars,
  faPlusSquare,
  faPlus,
  faMinusSquare,
  faMinusCircle,
  faSlidersH,
  faTrashAlt,
  faVenusMars,
  faLocationDot,
  faInfoCircle,
  faCalendarAlt,
  faPersonMilitaryPointing,
  faLanguage,
  faFileLines,
  faFile,
  faInfo,
  faListCheck,
  faSun,
  faMoon,
  faCheck,
  faWifi,
  faPrint,
  faSearch,
  faUserGroup
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faUser,
  faEye,
  faEyeSlash,
  faUnlockAlt,
  faMobileAlt,
  faXmark,
  faList,
  faHandshake,
  faUserAlt,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faCircleUser,
  faSignOut,
  faBars,
  faPlusSquare,
  faPlus,
  faMinusSquare,
  faMinusCircle,
  faSlidersH,
  faTrashAlt,
  faVenusMars,
  faLocationDot,
  faInfoCircle,
  faCalendarAlt,
  faPersonMilitaryPointing,
  faLanguage,
  faMicrosoft,
  faFileLines,
  faFile,
  faInfo,
  faListCheck,
  faSun,
  faMoon,
  faCheck,
  faWifi,
  faPrint,
  faSearch,
  faUserGroup,
);

const defaultTitle = "سامانه استخدام";
router.afterEach((to) => {
  nextTick(() => {
    document.title = to.meta.title || defaultTitle;
  });
});

createApp(App)
  .component("font-awesome-icon", FontAwesomeIcon)
  .use(store)
  .use(router)
  .use(Vue3Toasity, { rtl: true })
  .use(VueCookies)
  .mount("#app");
